export default __webpack_public_path__ + "static/media/HelveticaNeueMedium.17ecd376.woff";